import { render, staticRenderFns } from "./personal-reply-refer-form.vue?vue&type=template&id=baf59918&"
import script from "./personal-reply-refer-form.vue?vue&type=script&lang=js&"
export * from "./personal-reply-refer-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports